import { Link } from "react-router-dom";

export const TestSelector = () => {
  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 sm:px-6 py-8 sm:py-12 max-w-3xl">
        {/* Back link */}
        <div className="mb-6">
          <Link
            to="/guia-models"
            className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground transition-colors"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="m15 18-6-6 6-6" />
            </svg>
            Guia de models
          </Link>
        </div>

        {/* Header */}
        <div className="mb-10">
          <h1 className="text-2xl sm:text-3xl font-bold text-foreground mb-2">
            Test de coneixement
          </h1>
          <p className="text-muted-foreground text-sm sm:text-base">
            Posa a prova el que saps sobre el nom dels cotxes i tria el repte que vulguis.
          </p>
        </div>

        {/* Test cards */}
        <div className="grid sm:grid-cols-2 gap-5">
          {/* Card 1: Identifica la marca */}
          <Link
            to="/guia-models/test/marques"
            className="group bg-card border border-border rounded-2xl p-6 flex flex-col hover:border-foreground/30 hover:shadow-md transition-all duration-200"
          >
            <div className="text-3xl mb-4">🔍</div>
            <h2 className="text-lg font-bold text-foreground mb-2">
              Identifica la marca
            </h2>
            <p className="text-sm text-muted-foreground leading-relaxed mb-5 flex-1">
              Et mostrem un model de cotxe — com ara <span className="font-mono font-semibold text-foreground">430d xDrive</span> — i has d'endevinar a quina marca pertany.
            </p>
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-1.5">
                <span className="text-[11px] font-bold text-muted-foreground uppercase tracking-widest">Dificultat</span>
                <div className="flex gap-0.5 ml-1">
                  {[1, 2, 3].map((i) => (
                    <div
                      key={i}
                      className={`w-2 h-2 rounded-full ${i <= 2 ? "bg-foreground" : "bg-border"}`}
                    />
                  ))}
                </div>
              </div>
              <span className="text-sm font-semibold text-foreground group-hover:translate-x-0.5 transition-transform">
                Jugar →
              </span>
            </div>
          </Link>

          {/* Card 2: Desxifra el model */}
          <Link
            to="/guia-models/test/desxifra"
            className="group bg-card border border-border rounded-2xl p-6 flex flex-col hover:border-foreground/30 hover:shadow-md transition-all duration-200"
          >
            <div className="text-3xl mb-4">🧪</div>
            <h2 className="text-lg font-bold text-foreground mb-2">
              Desxifra el model
            </h2>
            <p className="text-sm text-muted-foreground leading-relaxed mb-5 flex-1">
              Et mostrem una marca i el nom d'un model. Has de triar la interpretació correcta de cada part del nom.
            </p>
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-1.5">
                <span className="text-[11px] font-bold text-muted-foreground uppercase tracking-widest">Dificultat</span>
                <div className="flex gap-0.5 ml-1">
                  {[1, 2, 3].map((i) => (
                    <div
                      key={i}
                      className="w-2 h-2 rounded-full bg-foreground"
                    />
                  ))}
                </div>
              </div>
              <span className="text-sm font-semibold text-foreground group-hover:translate-x-0.5 transition-transform">
                Jugar →
              </span>
            </div>
          </Link>

          {/* Card 3: Endevina el preu */}
          <Link
            to="/endevina-preu"
            className="group bg-card border border-border rounded-2xl p-6 flex flex-col hover:border-foreground/30 hover:shadow-md transition-all duration-200"
          >
            <div className="text-3xl mb-4">💶</div>
            <h2 className="text-lg font-bold text-foreground mb-2">
              Endevina el preu
            </h2>
            <p className="text-sm text-muted-foreground leading-relaxed mb-5 flex-1">
              Et mostrem la foto i les especificacions d'un cotxe. Tens 5 intents per encertar-ne el preu: et diem si és més alt o més baix.
            </p>
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-1.5">
                <span className="text-[11px] font-bold text-muted-foreground uppercase tracking-widest">Dificultat</span>
                <div className="flex gap-0.5 ml-1">
                  {[1, 2, 3].map((i) => (
                    <div
                      key={i}
                      className={`w-2 h-2 rounded-full ${i <= 2 ? "bg-foreground" : "bg-border"}`}
                    />
                  ))}
                </div>
              </div>
              <span className="text-sm font-semibold text-foreground group-hover:translate-x-0.5 transition-transform">
                Jugar →
              </span>
            </div>
          </Link>
        </div>

        {/* Note */}
        <p className="mt-6 text-xs text-muted-foreground/60 text-center">
          20 preguntes aleatòries per sessió · Les preguntes es barregen cada cop
        </p>
      </div>
    </div>
  );
};
